import FondationsServiceModel from '@/models/FondationsServiceModel';

export default class LanguageModel extends FondationsServiceModel {
	static get path(): string {
		return '/languages';
	}

	public get label(): string {
		return this.get('lang', '');
	}

	public get locale(): string {
		return this.get('locale', '');
	}
}
